import { RAZORPAY_LIVE_KEY_ID } from '../constants/configConstants';
import { colors } from '../constants/colors';

// Initialize Razorpay checkout
export const initializeRazorpayCheckout = (options) => {
    return new Promise((resolve, reject) => {
        try {
            if (!window.Razorpay) {
                reject(new Error('Razorpay SDK not loaded'));
                return;
            }

            const rzp = new window.Razorpay({
                ...options,
                handler: function (response) {
                    resolve(response);
                },
                modal: {
                    ondismiss: function () {
                        reject(new Error('Payment cancelled by user'));
                    }
                }
            });

            rzp.open();
        } catch (error) {
            reject(error);
        }
    });
};

// Get Razorpay configuration
export const getRazorpayConfig = () => {
    return {
        key: RAZORPAY_LIVE_KEY_ID,
        currency: 'INR',
        name: 'Codeinfoway',
        description: 'Order Payment',
        theme: {
            color: colors.secondary
        }
    };
}; 